// CPG Synergy — Complete Website Content (Single Source of Truth)
// Extracted from https://www.cpgsynergy.agency/ on 2026-03-12
// RULE: Every word comes from the original site. Zero content invention.

export const siteContent = {
  meta: {
    siteName: "CPG Synergy",
    tagline: "AI Marketing Platform",
    phone: "(928) 899-2208",
    email: "info@cpgsynergy.agency",
    url: "https://www.cpgsynergy.agency",
    copyright: "\u00a9 2024, All Rights Reserved",
    operatedBy: "121 LLC",
  },

  navigation: {
    primary: ["Platform", "Agency", "Pricing"],
    resources: [
      "Resource Center",
      "Case Studies",
      "Blog Posts",
      "Webinars",
      "Podcasts",
      "News",
    ],
    actions: ["Contact Us", "Book a Demo", "Login", "Get Started"],
  },

  // =============================================
  // HOMEPAGE
  // =============================================
  homepage: {
    hero: {
      badge: "AI Marketing Platform",
      headline: "Automate Your Social Media & Influencer Marketing Toolkit",
      subheadline:
        "Save your team the headache, and partner with influencers who drive real results. Join the hundreds of other companies saving hundreds of hours a month on social media.",
      cta_primary: "Book a Demo",
      cta_secondary: "Get Started",
    },

    platformLogos: [
      "Google",
      "YouTube",
      "Meta",
      "LinkedIn",
      "TikTok",
      "Reddit",
      "Twitch",
      "Snapchat",
    ],

    caseStudies: [
      {
        name: "Freeway Phoenix",
        stats: [
          { label: "Impressions", value: "29,505" },
          { label: "ROAS", value: "3.5x" },
          { label: "Total Engagement Metrics", value: "\u2191 180%" },
          { label: "Reactions", value: "\u2191 101.3%" },
        ],
      },
      {
        name: "HeroVation",
        stats: [
          { label: "Views", value: "16.2M" },
          { label: "Engagements", value: "12.2M" },
          { label: "Impressions", value: "7.1M" },
          { label: "Awareness", value: "+23PT" },
        ],
      },
    ],

    howItWorks: {
      headline: "How It Works",
      description: "",
      steps: [
        {
          number: 1,
          title: "Discover Influencers",
          features: [
            {
              title: "Search Using Authenticity Metrics",
              description: "",
            },
            {
              title: "Engagement Insights",
              description: "",
            },
            {
              title: "Value Based Partnerships",
              description: "",
            },
          ],
        },
        {
          number: 2,
          title: "Manage Campaigns Effortlessly",
          features: [
            {
              title: "Automate Workflows",
              description: "",
            },
            {
              title: "Centralized Dashboard",
              description: "",
            },
            {
              title: "Collaboration Tools",
              description: "",
            },
          ],
        },
        {
          number: 3,
          title: "Seamless Product Fulfillment",
          features: [
            {
              title: "Product Gifting",
              description: "",
            },
            {
              title: "Comprehensive Integrations",
              description: "",
            },
            {
              title: "Hassle-Free Affiliate Marketing",
              description: "",
            },
          ],
        },
        {
          number: 4,
          title: "Maximize Your Reach with Organic Content",
          features: [
            {
              title: "Social Listening & Asset Management",
              description: "",
            },
            {
              title: "Content Approval Process",
              description: "",
            },
            {
              title: "Post Influencer Content to Your Accounts",
              description: "",
            },
          ],
        },
        {
          number: 5,
          title: "Track & Measure ROI",
          features: [
            {
              title: "Conversion Tracking",
              description: "",
            },
            {
              title: "Performance Based Pay",
              description: "",
            },
            {
              title: "Use In-Depth Analysis",
              description: "",
            },
          ],
        },
      ],
    },

    testimonials: [
      {
        quote:
          "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur",
        author: "Albert Flores",
        role: "Co-Founder",
        company: "Speedy Chow",
      },
    ],

    integrations: {
      headline: "Integrations",
      description: "",
      platforms: [
        "Google",
        "YouTube",
        "Meta",
        "LinkedIn",
        "TikTok",
        "Reddit",
        "Twitch",
        "Snapchat",
      ],
    },

    resources: [
      {
        title:
          "Why 90% of Small Businesses are Turning to Short-Form Content",
        author: "Cameron Weber",
        date: "Oct 18, 2025",
        excerpt:
          "Learn how to boost engagement & sales for your business with short-form videos using Youtube Shorts, IG Reels, and more.",
      },
      {
        title:
          "Ultra-Nano Influencers: ROAS Powerhouses You Can't Ignore",
        author: "Cameron Weber",
        date: "Feb 16, 2025",
        excerpt:
          "Learn how to boost your brand's social media presence and engagement rates by using the power of Ultra-Nano Influencers.",
      },
    ],

    faq: [
      {
        question: "What are influencer marketing platforms?",
        answer:
          "Influencer marketing platforms are technology-driven solutions that connect brands and businesses with social media influencers. These platforms act as intermediaries, providing a centralized hub where brands can discover, collaborate with, and manage influencers for their marketing campaigns.",
      },
      {
        question: "What are influencer marketing softwares?",
        answer:
          "Influencer marketing platforms are technology-driven solutions that connect brands and businesses with social media influencers. These platforms act as intermediaries, providing a centralized hub where brands can discover, collaborate with, and manage influencers for their marketing campaigns.",
      },
      {
        question: "What are influencer marketing tools?",
        answer:
          "Influencer marketing platforms are technology-driven solutions that connect brands and businesses with social media influencers. These platforms act as intermediaries, providing a centralized hub where brands can discover, collaborate with, and manage influencers for their marketing campaigns.",
      },
      {
        question: "What do influencer marketing platforms do?",
        answer:
          "Influencer marketing platforms are technology-driven solutions that connect brands and businesses with social media influencers. These platforms act as intermediaries, providing a centralized hub where brands can discover, collaborate with, and manage influencers for their marketing campaigns.",
      },
    ],

    cta: {
      headline: "Start Your Journey Today",
      description:
        "Chosen by the best marketing experts, agencies, and industry professionals. Get started today for free.",
      button: "Get Started",
    },
  },

  // =============================================
  // AGENCY PAGE
  // =============================================
  agencyPage: {
    hero: {
      headline: "Utilize Our Social Media Experts To Drive Real Results",
      subheadline:
        "Full service social media and influencer marketing agency helping scale and develop creative strategies to drive real results for your brand.",
      cta_primary: "Talk with an Expert",
    },

    performanceMetrics: [
      { label: "ROI", value: "$307K" },
      { label: "Views", value: "16.2M" },
      { label: "Engagements", value: "12.1K" },
      { label: "Impressions", value: "7.4M" },
    ],

    caseStudiesSection: {
      headline: "Our Recent Case Studies",
      subtitle:
        "Don't just take our word for it, see our clients' real world results",
      cta: "View All",
    },

    services: {
      headline: "Fully Tailored Services",
      subtitle: "Customized solutions for you're unique needs.",
      items: [
        {
          title: "Partner with Our Experts",
          description:
            "Let us handle the heavy lifting. From campaign creation to detailed reporting, we've got you covered from start to finish. Our team of experts will manage every aspect of your campaign, ensuring a seamless and efficient process.",
        },
        {
          title: "Social Media Management",
          description:
            "Let us handle everything from content scheduling and posting to community engagement and performance analysis, to ensure your brand maintains a strong online presence.",
        },
        {
          title: "Full Service Digital Marketing",
          description:
            "Want more than influencer marketing help? From SEO, email marketing, paid social and much more. We'll ensure you're brand reaches it's full potential.",
        },
        {
          title: "Tailored Campaign Strategies",
          description:
            "We'll create custom strategies to even get started or how the latest TikTok trends impact your brand. Our team will tailor a unique approach specifically for your business, ensuring you have a strong foundation right from the beginning.",
        },
        {
          title: "Influencer Event Marketing",
          description:
            "Want your pop-up or event to take center stage online? Let us manage the details and make your event a digital sensation. We specialize in transforming your physical events into engaging online experiences that capture the attention of your target audience.",
        },
        {
          title: "Additional Services",
          description:
            "We also offer one-off campaigns, social media templates, and online training to meet all your influencer marketing needs. Whether you need a quick, impactful campaign or long-term strategy support, we've got you covered.",
        },
      ],
      cta: "Contact Us",
    },

    influencers: {
      headline: "Our Top Influencers",
      subtitle:
        "Connect your daily tools to manage every aspect of your campaigns in one place",
      items: [
        {
          name: "Sara Shultz",
          role: "Travel Photographer",
          stats: {
            subscribers: "2.5K",
            awareness: "+23PT",
            engagements: "12.1K",
            impressions: "7.4M",
          },
        },
        {
          name: "Wailer Saudi",
          role: "TikToker",
          stats: {
            subscribers: "2.5K",
            awareness: "+23PT",
            engagements: "12.1K",
            impressions: "7.4M",
          },
        },
        {
          name: "Kristin Watson",
          role: "Facebook Influencer",
          stats: {
            subscribers: "2.5K",
            awareness: "+23PT",
            engagements: "12.1K",
            impressions: "7.4M",
          },
        },
        {
          name: "Mario Eliva",
          role: "Youtube Expert",
          stats: {
            subscribers: "2.5K",
            awareness: "+23PT",
            engagements: "12.1K",
            impressions: "7.4M",
          },
        },
        {
          name: "Albert Flores",
          role: "TikToker",
          stats: {
            subscribers: "2.5K",
            awareness: "+23PT",
            engagements: "12.1K",
            impressions: "7.4M",
          },
        },
      ],
    },

    solutions: {
      headline: "Marketing Success Solutions",
      subtitle:
        "Tailored for both small teams and newcomers, these tools ensure your marketing efforts are efficient and impactful.",
      items: [
        {
          title: "SOPs for Marketing Teams",
          description:
            "Streamline your efforts with our easy to follow standard operating procedures perfect for small teams or those new to influencer marketing. Our SOPs, will take you from a beginner to expert in no time, all without breaking the bank.",
          cta: "Learn More",
        },
        {
          title: "Social Media Templates",
          description:
            "Tailored to your brand, our platform enhances your online presence with a variety of easy-to-use customizable themes and templates. Choose from a wide range of design options that can be personalized to reflect your unique brand identity.",
          cta: "Learn More",
        },
      ],
    },

    newsletter: {
      headline: "Don't Miss Our Exclusive Content",
      subtitle:
        "Sign up to get news, tools, advice, and stories right in your inbox.",
      successMessage: "Thank you! Your submission has been received!",
      errorMessage:
        "Oops! Something went wrong while submitting the form.",
      legalNotice:
        "By using this form you agree with the storage and handling of your data by CPG Synergy. Read our Terms of Service & Privacy Policy",
    },
  },

  // =============================================
  // PRICING PAGE
  // =============================================
  pricingPage: {
    headline: "Platform Pricing",
    subtitle: "Choose the best plan that best fits your needs.",
    billingToggle: {
      monthly: "Monthly",
      yearly: "Yearly",
      saveBadge: "Save 30-40%",
    },
    plans: [
      {
        name: "Starter Plan",
        tagline:
          "Perfect for brands just starting out on their influencer marketing journey.",
        price: {
          monthly: "$1,200",
          yearly: "$800",
        },
        features: [
          "Single user access to all essential features.",
          "Manage multiple campaigns simultaneously.",
          "Integrate your customer base",
        ],
        cta: "Try for Free",
        highlighted: false,
      },
      {
        name: "Professional Plan",
        badge: "Most Popular",
        tagline:
          "Ideal for growing businesses looking to collaborate and scale their influencer marketing efforts effortlessly.",
        price: {
          monthly: "$2,500",
          yearly: "$1,800",
        },
        features: [
          "Allow up to three team members to access and manage campaigns.",
          "Run as many campaigns as you need.",
          "Integrate your customer base",
        ],
        cta: "Try for Free",
        highlighted: true,
      },
      {
        name: "Enterprise Plan",
        tagline:
          "Tailored for larger teams and organizations that need a robust and customizable solution.",
        price: {
          monthly: "Contact Sales",
          yearly: "Contact Sales",
        },
        features: [
          "Get a plan specifically designed to meet your unique business needs.",
          "Unlimited seats, campaigns, and dedicated support.",
          "Integrate your customer base",
        ],
        cta: "Try for Free",
        highlighted: false,
      },
    ],
    includedFeatures: {
      headline: "Features",
      description:
        "Discover and connect with the right creators for your brand using content, audience, and performance insights. Simplify outreach with direct email contacts and manage all communications effortlessly on our platform.",
      items: [
        "Discover Influencers",
        "Campaign Management",
        "Product Fulfilment",
        "Social Media Management",
        "ROI Reporting & Analytics",
      ],
    },
  },

  // =============================================
  // CONTACT PAGE
  // =============================================
  contactPage: {
    hero: {
      headline: "Contact Our Experts",
      subtitle:
        "Have questions or need assistance? Our team is here to help.",
    },
    demoSection: {
      headline: "Book a Demo",
      description:
        "Schedule a demo to explore our product features and benefits. Our team is ready showcase how our solution can meet your needs.",
    },
    form: {
      fields: [
        { name: "name", label: "Name", type: "text" },
        { name: "email", label: "Work Email", type: "email" },
        { name: "company", label: "Company Name", type: "text" },
        {
          name: "type",
          label: "What best describes you?",
          type: "select",
          options: ["Agency", "Company", "Influencer", "Other"],
        },
      ],
      consent:
        "By registering, you confirm that you agree to the processing of your personal data by CPG Synergy as described in our Terms of Services & Privacy Policy",
      submitButton: "Book a Demo",
    },
  },

  // =============================================
  // CASE STUDIES (DETAILED)
  // =============================================
  caseStudies: {
    freewayPhoenix: {
      name: "Freeway Phoenix",
      founder: "Daniela Santangelo",
      founderTitle: "Two-time founder, community leader, mentor",
      mission:
        "On-ramp into Arizona's startup community; aims to be the most accessible large-market startup ecosystem in the country",
      background:
        "Freeway PHX connects founders, investors, and jobseekers in the Phoenix area. The company hosts a bi-annual Tech Talent Summit.",
      challenge:
        "Building an engaging social media presence that genuinely fosters community in today's fragmented attention economy. Limited resources and time constraints. Need for scalable, authentic presence without overextending capabilities. Previous content had low engagement (less than 4% average on most posts).",
      solution:
        "Reviewed existing strategy and identified founder-led content as strongest performer. Developed content processes suited for one-person teams or freelancers. Tested various content types, using Instagram as test channel. Prioritized founder-led authentic content. Established content calendar and approval processes. Activated community members for organic amplification. Created short-form video promos, recaps, and testimonial videos for Tech Talent Summit.",
      goals: [
        "Drive event awareness and LinkedIn engagement through short-form content",
        "Highlight jobs, events, and industry news",
        "Encourage community members and leaders to share content via business development",
        "Boost Tech Talent Summit ticket sales",
      ],
      results: {
        advertising: [
          { label: "ROAS", value: "3.5x" },
          { label: "CPM", value: "$3.71" },
          { label: "CAC", value: "$2.20" },
        ],
        socialMedia: [
          { label: "Total Organic Impressions", value: "29,505" },
          { label: "Average Engagement Rate", value: "13.8%" },
          {
            label: "Total Engagement vs. Competitors",
            value: "180% increase",
          },
          { label: "New Followers", value: "Up 23.5%" },
          { label: "Comments", value: "Up 185.2%" },
          { label: "Reposts", value: "Up 104.8%" },
          { label: "Reactions", value: "Up 162.8%" },
        ],
        emailMarketing: [
          { label: "Click-Through Rate (CTR)", value: "16.93%" },
          { label: "Click Rate", value: "6.4%" },
        ],
      },
      keyInsight:
        "Authenticity is the number one metric for success on social media.",
      author: "Cameron Weber",
      authorTitle: "Founder & CEO of CPG Synergy",
    },
    herovation: {
      name: "HeroVation",
      stats: [
        { label: "Views", value: "16.2M" },
        { label: "Engagements", value: "12.2M" },
        { label: "Impressions", value: "7.1M" },
        { label: "Awareness", value: "+23PT" },
      ],
      // NOTE: Limited detailed content available from public page
    },
  },

  // =============================================
  // BLOG POSTS
  // =============================================
  blogPosts: [
    {
      title:
        "Why 90% of Small Businesses are Turning to Short-Form Content",
      author: "Cameron Weber",
      date: "Oct 18, 2025",
      excerpt:
        "Learn how to boost engagement & sales for your business with short-form videos using Youtube Shorts, IG Reels, and more.",
      cta: "Read Now",
    },
    {
      title:
        "Ultra-Nano Influencers: ROAS Powerhouses You Can't Ignore",
      author: "Cameron Weber",
      date: "Feb 16, 2025",
      excerpt:
        "Learn how to boost your brand's social media presence and engagement rates by using the power of Ultra-Nano Influencers.",
    },
  ],

  // =============================================
  // RESOURCES PAGE
  // =============================================
  resourcesPage: {
    headline: "Social Media Resources",
    subtitle: "Learn directly from our experts to scale your efforts online.",
    categories: [
      "Blogs",
      "Case Studies",
      "Podcasts",
      "News",
      "Webinars",
      "Courses",
      "Industry Reports",
      "Guides",
    ],
  },

  // =============================================
  // FOOTER
  // =============================================
  footer: {
    description:
      "Elevate Brand Awareness, Drive Traffic, and Use Data-Driven Insights to Scale Sales and Become a Direct-to-Consumer Powerhouse",
    homeLinks: [
      { label: "Platform", href: "/platform" },
      { label: "Agency", href: "/agency" },
      { label: "Pricing", href: "/pricing" },
      { label: "Contact Us", href: "/contact" },
      { label: "FAQ", href: "/#faq" },
    ],
    resourceLinks: [
      { label: "Blog", href: "/resources/blog" },
      { label: "Case Studies", href: "/resources/case-studies" },
      { label: "Podcasts", href: "/resources/podcasts" },
      { label: "News & Media", href: "/resources/news" },
      { label: "Webinars", href: "/resources/webinars" },
      { label: "Courses", href: "/resources/courses" },
      { label: "Industry Reports", href: "/resources/reports" },
      { label: "Guides", href: "/resources/guides" },
    ],
    legalLinks: [
      { label: "Terms of Service", href: "/legal" },
      { label: "Privacy Policy", href: "/legal" },
      { label: "Cookie Notice", href: "/legal" },
    ],
    socialLinks: [
      { platform: "Facebook", href: "#" },
      { platform: "X", href: "#" },
      { platform: "Instagram", href: "#" },
      { platform: "LinkedIn", href: "#" },
      { platform: "TikTok", href: "#" },
      { platform: "YouTube", href: "#" },
    ],
    copyright: "\u00a9 2024, All Rights Reserved",
  },
};
